import axios from 'axios';
import React, { Suspense, useEffect } from 'react';
import { AppProvider } from 'Context/AppContext.js';
import { connectSocket, disconnectSocket } from 'config/socket';
import { getApiBaseUrl, getBxiApiKey } from 'config/api';
import { initAuthFromStorage } from 'utils/authToken';
import apiClient, { v1Backend } from 'services/api/client';
import DashboardRouter from 'routes/DashboardRouter';
import ErrorBoundary from 'components/ErrorBoundary.jsx';
import { ToastContainer } from 'react-toastify';
import initializeLimeChatWhatsapp from 'utils/initializeLimeChatWhatsapp';

const BXILogo = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/logos/bxi-logo.png';

axios.defaults.baseURL = getApiBaseUrl();
axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;
initAuthFromStorage(axios, v1Backend, apiClient);
axios.defaults.headers.bxiapikey = getBxiApiKey();

const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'https://bxiworld.com';
const LISTING_URL = process.env.REACT_APP_LISTING_URL || 'https://listings.bxiworld.com';

window.LANDING_URL = LANDING_URL;
window.LISTING_URL = LISTING_URL;

const Loader = () => {
  return (
    <div
      className='loader'
      style={{
        width: '100vw',
        height: '100vh',
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={BXILogo}
        style={{ width: '300px', height: '300px' }}
        alt='BXI Logo'
        title='BXI Logo'
      />
    </div>
  );
};

function App() {
  const limeChatScriptId = 'limechat-sdk-script';

  const initializeLimeChat = () => {
    if (typeof window === 'undefined') return;
    const BASE_URL = process.env.REACT_APP_LIMECHAT_URL || 'https://app.limechat.ai';

    if (window.chatwootSDK?.run) {
      window.chatwootSDK.run({
        websiteToken: 'HyToUUEYVaDNr1v8UC57A1vz',
        baseUrl: BASE_URL,
      });
      return;
    }

    const existingScript = document.getElementById(limeChatScriptId);
    if (existingScript) {
      return;
    }

    const g = document.createElement('script');
    g.id = limeChatScriptId;
    g.src =
      'https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/LC_sdk/v1/sdk.js';
    g.defer = true;

    const s = document.getElementsByTagName('script')[0];
    if (!s?.parentNode) return;

    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK?.run({
        websiteToken: 'HyToUUEYVaDNr1v8UC57A1vz',
        baseUrl: BASE_URL,
      });
    };
  };

  useEffect(() => {
    connectSocket();

    return () => {
      disconnectSocket();
    };
  }, []);

  // The app renders immediately; only the third-party chat widgets wait, so
  // their scripts don't compete with the first paint.
  useEffect(() => {
    const timer = setTimeout(() => {
      initializeLimeChat();
      initializeLimeChatWhatsapp();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  return (
    <ErrorBoundary>
      <AppProvider>
        <div className='App'>
          <ToastContainer style={{ fontSize: '14px' }} />
          <Suspense fallback={<Loader />}>
            <DashboardRouter />
          </Suspense>
        </div>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
